<template>
  <div
    :class="
      `container container-${theme}${
        hasFixedButton ? ' container-fixed-button' : ''
      } layout-${layout}`
    "
  >
    <wrap-container class="w100">
      <p class="title" @click="toggleText">Términos y condiciones</p>
      <footer>
        <transition name="fade">
          <slot v-if="isTextVisible" />
        </transition>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer },
  props: {
    text: String,
    hasFixedButton: Boolean,
    theme: {
      type: String,
      default: "dark"
    },
    layout: {
      type: String,
      default: "full"
    }
  },
  data() {
    return {
      isTextVisible: false
    };
  },
  methods: {
    toggleText() {
      this.isTextVisible = !this.isTextVisible;
    }
  }
};
</script>

<style scoped>
.title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  cursor: pointer;
}

div.container-light .title {
  color: #000000;
}

div.container-dark .title {
  color: #000;
}

.title::before {
  content: url("../../assets/img/ofertaNomina/icons/plus.svg");
  padding-right: 5px;
}

div.container {
  font-size: 12px;
  line-height: 1.5em;
  padding: 17px;
  text-align: justify;
  margin-bottom: 0px;
}

div.container-dark {
  background: #f4f4f4;
  color: #000;
  margin-bottom: 80px;
}

div.container-light {
  background: #e9e9e9;
  color: #000000;
}

img {
  display: block;
  width: 112px;
  height: auto;
  margin-top: 16px;
}

div.container-fixed-button {
  padding-bottom: 90px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

div.container.layout-boxed {
  background: transparent;
  padding: 0 17px;
}

div.container-dark.layout-boxed .wrap-container {
  background: #f4f4f4;
  color: #000;
}

div.container-light.layout-boxed .wrap-container {
  background: #e9e9e9;
  color: #000000;
}

div.container.layout-boxed .wrap-container {
  padding: 17px 30px;
  border-radius: 16px;
}

@media screen and (max-width: 1024px) {
  div.container-light .title {
    font-size: 15px;
    margin: 0px;
  }

  div.container-light {
    max-height: 56px;
  }

  div.container-light footer p {
    margin-top: 40px;
  }
}
@media screen and (max-width: 600px) {
  .title::before {
    right: 20px;
    position: absolute;
  }
  div.container.layout-boxed .title::before {
    right: 35px;
  }
}
</style>
